// extracted by mini-css-extract-plugin
export var backdropBlur = "_lf-0";
export var contentCard = "_lf-5";
export var frame = "_lf-2";
export var image = "_lf-4";
export var imagePane = "_lf-3";
export var modal = "_lf-1";